// Copyright (c) StrangeBee 2023

import { ActionsList } from '@Atoms/ActionsList/ActionsList';
import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { PinButton, PinType } from '@Molecules/Pin';
import { ListActionType } from '@Types';
import { Alert } from 'antd';
import React, { ReactElement, ReactNode } from 'react';

import './EntityHeader.scss';

interface EntityHeaderProps {
    onBackClick: () => void;
    pinData?: PinType;
    actionList?: Record<string, ListActionType>;
    extraAction?: ReactNode;
    title?: string | ReactNode;
    alert?: ReactNode;
}

export const EntityHeader = ({
    onBackClick,
    pinData,
    actionList,
    extraAction,
    title,
    alert,
}: EntityHeaderProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <div className="entity-header">
            <div className="entity-header__top">
                <div className="entity-header__navigation">
                    <THButton type="link" onClick={onBackClick}>{`< ${i('general.back-to-list')}`}</THButton>
                    <span className="entity-header__title">{title}</span>
                </div>

                <div className="entity-header__actions">
                    {extraAction}
                    {pinData && <PinButton data={pinData} />}
                    {actionList && <ActionsList actionList={actionList} isIcon scope="single" />}
                </div>
            </div>

            {alert && (
                <div className="entity-header__bottom">
                    <Alert type="error" className="entity-header__notification" message={alert} />
                </div>
            )}
        </div>
    );
};
